module.exports = {"410621001":"卫溪街道","410621002":"浚州街道","410621003":"黎阳街道","410621004":"伾山街道","410621101":"善堂镇","410621102":"屯子镇","410621104":"新镇镇","410621105":"小河镇","410621107":"卫贤镇","410621108":"王庄镇","410621201":"白寺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410621.json
// module id = 1448
// module chunks = 0